export enum ProcessTaskStatus {
    cancelled = 'cancelled',
    closed = 'closed',
    inProgress = 'inProgress',
    open = 'open',
}

export function isProcessTaskStatus(value: unknown): value is ProcessTaskStatus {
    return (
        value === ProcessTaskStatus.cancelled ||
        value === ProcessTaskStatus.closed ||
        value === ProcessTaskStatus.inProgress ||
        value === ProcessTaskStatus.open
    );
}
